import { Link } from 'react-router-dom';
import { Button, Card, CardBody } from '../components/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 p-4">
      <Card className="max-w-md text-center">
        <CardBody className="space-y-4">
          <div className="text-6xl">🔍</div>
          <h1 className="text-2xl font-bold text-gray-900">
            Página no encontrada
          </h1>
          <p className="text-gray-600">
            La página que buscas no existe o ha sido movida.
          </p>
          <Link to="/">
            <Button>Volver al inicio</Button>
          </Link>
        </CardBody>
      </Card>
    </div>
  );
}
